'use client'

import Link from 'next/link'
import { Button } from '@/components/ui/button'
import { Clock } from 'lucide-react'
import { useTranslations } from 'next-intl'

export function PricingComingSoon() {
  const t = useTranslations('pricing')

  return (
    <section className="py-32 px-4 relative overflow-hidden">
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-violet-600/10 rounded-full blur-[128px]" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-fuchsia-600/10 rounded-full blur-[128px]" />

      <div className="container mx-auto max-w-2xl text-center relative">
        <div className="inline-flex p-4 rounded-2xl bg-violet-500/10 border border-violet-500/20 mb-8">
          <Clock className="h-8 w-8 text-violet-400" />
        </div>

        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          {t('comingSoonTitle')}
        </h1>
        <p className="text-xl text-zinc-400 mb-4">
          {t('comingSoonSubtitle')}
        </p>
        <p className="text-zinc-500 mb-10 max-w-md mx-auto">
          {t('comingSoonDesc')}
        </p>

        <Link href="/signup">
          <Button
            size="lg"
            className="text-lg px-8 bg-gradient-to-r from-violet-600 to-fuchsia-600 hover:from-violet-700 hover:to-fuchsia-700 hover:shadow-[0_0_30px_rgba(139,92,246,0.4)] transition-all"
          >
            {t('comingSoonCta')}
          </Button>
        </Link>
      </div>
    </section>
  )
}
